import noop from 'lodash/noop';
import { useRef, useEffect } from 'react';

var useSubMenuFocus = function useSubMenuFocus() {
  var localRef = useRef(null);
  var originalFocus = useRef(noop);

  var storeAndMakeCurrentFocusMethodNoop = function storeAndMakeCurrentFocusMethodNoop() {
    if (!localRef.current) {
      return;
    }

    originalFocus.current = localRef.current.focus;
    localRef.current.focus = noop;
  };

  var restoreInitialFocusMethod = function restoreInitialFocusMethod() {
    if (!localRef.current) {
      return;
    }

    localRef.current.focus = originalFocus.current;
  };

  var setRefFocusMethodNoop = function setRefFocusMethodNoop() {
    if (!localRef.current) {
      return;
    }

    localRef.current.focus = noop;
  };

  useEffect(function () {
    var keydownListener = function onKeydownHandler() {
      restoreInitialFocusMethod();
    };

    document.addEventListener('keydown', keydownListener);
    storeAndMakeCurrentFocusMethodNoop();
    return function () {
      document.removeEventListener('keydown', keydownListener);
    };
  }, []);
  return [localRef, setRefFocusMethodNoop, storeAndMakeCurrentFocusMethodNoop];
};

export { useSubMenuFocus };